// @flow

import React from 'react';
import placeholderImage from 'img/fallback/logo_image_item_file_default.png';
import TrackEvent from 'components/TrackEvent';

type Props = {
  job: {
    id: number | string,
    title: string,
    url: string,
    place: any,
    companyName: string,
    file: any
  },
  trackEventName: string,
  trackClickName: string
};

export default ({
  job: {
    id,
    title,
    url,
    place,
    companyName,
    file
  },
  trackEventName,
  trackClickName
}: Props) => {
  const trackProperties = JSON.stringify({
    event: trackClickName,
    properties: {
      job_id: id,
      company_name: companyName,
      marker: ['third_party_job']
    }
  });

  return (
    <div className="card card_job">
      <a href={url} title={title} target="_blank" rel="noreferrer" className="card__img" data-track={trackProperties}>
        <img
          src={file ? file.profile.url : placeholderImage}
          title={file ? file.title : title}
          alt={file ? file.title : title}
        />
      </a>
      <div className="card__overview">
        <a href={url} target="_blank" rel="noreferrer" className="card__title" data-track={trackProperties}>{title}</a>
        <div className="card__company">{companyName} {place ? `in ${place.city}` : '' }</div>
      </div>
      <TrackEvent name={trackEventName} properties={{
        job_id: id,
        company_name: companyName,
        marker: ['third_party_job']
      }}/>
    </div>
  );
};
